module.exports = __webpack_public_path__ + "ec9878cf7716697d96f7ef49ec93d8dc.MP3";